import { motion } from 'framer-motion';
import { CSSProperties, forwardRef } from 'react';
import { getResolvedSpacing, getResolvedStyles } from '~/themes/utils';
import { IAnimatedBoxShowHideProps } from '../interfaces';

export const AnimatedBoxShowHide = forwardRef<HTMLDivElement, IAnimatedBoxShowHideProps>(
  ({ className, children, style, direction = 'column', isShow, ...rest }, ref) => {
    const baseStyles: CSSProperties = {
      display: 'flex',
      flexDirection: direction,
      ...getResolvedSpacing(rest),
      ...style,
    };

    const { styles, htmlProps } = getResolvedStyles(baseStyles, rest);

    return (
      <motion.div
        className={className}
        style={styles}
        ref={ref}
        {...htmlProps}
        initial={isShow ? 'show' : 'hide'}
        animate={isShow ? 'show' : 'hide'}
        transition={{ duration: 0.3 }}
        variants={{
          hide: { opacity: 0 },
          show: { opacity: 1 },
        }}
      >
        {children}
      </motion.div>
    );
  },
);

AnimatedBoxShowHide.displayName = 'AnimatedBoxShowHide';
